module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_archive_remoteEntry_mjs_5eacc7ee__;